import Router  from './routes/routes';
import './index.css'
function App() {
  return ( <Router /> )
}

export default App
